import { render, staticRenderFns } from "./NewArrivals.vue?vue&type=template&id=75606e6a&scoped=true&"
import script from "./NewArrivals.vue?vue&type=script&lang=js&"
export * from "./NewArrivals.vue?vue&type=script&lang=js&"
import style0 from "./NewArrivals.vue?vue&type=style&index=0&id=75606e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75606e6a",
  null
  
)

export default component.exports